import { Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';

import { Text } from 'common';

import { BlockDurationField } from '../../../ConfigFields/Duration';

interface SchedulingConfigsSeriesAppointmentBlockProps {
  fieldNamePrefix: string;
}

export function SchedulingConfigsSeriesAppointmentBlock(
  props: SchedulingConfigsSeriesAppointmentBlockProps
) {
  const { fieldNamePrefix } = props;
  return (
    <Stack gap={1}>
      <Text variant="heading5">Series Appointment Configurations</Text>
      <BlockDurationField
        variant="BlockValueTemplate"
        fieldName={`${fieldNamePrefix}.customConfigs.scheduleAppointmentSeriesMinTime`}
        allowedUnits={[FlowDurationUnits.Minutes, FlowDurationUnits.Hours, FlowDurationUnits.Days]}
        valueLabel="Minimum time between appointments"
        unitFieldNameSuffix="units"
        defaultUnit={FlowDurationUnits.Minutes}
        valueHelperText="Hide slots before this amount of time (from time of previous appointment)"
        toggleLabel="Enable Minimum time between appointments"
        required={false}
      />
      <BlockDurationField
        variant="BlockValueTemplate"
        fieldName={`${fieldNamePrefix}.customConfigs.scheduleAppointmentSeriesMaxTime`}
        allowedUnits={[FlowDurationUnits.Minutes, FlowDurationUnits.Hours, FlowDurationUnits.Days]}
        valueLabel="Maximum time between appointments"
        unitFieldNameSuffix="units"
        defaultUnit={FlowDurationUnits.Minutes}
        valueHelperText="Hide slots after this amount of time (from time of previous appointment)"
        toggleLabel="Enable Maximum time between appointments"
        required={false}
      />
    </Stack>
  );
}
